import { useRef } from "react";
const useQueueRef = () => useRef([]);
var useQueueRef_default = useQueueRef;
export {
  useQueueRef_default as default
};
